<template>
    <v-footer class="footer d-none d-md-flex"
      color="blue darken-4"
      app
    >
      <span class="white--text">TESDA XI RTC-KorPhil Davao &copy; 2020. All Rights Reserved.</span>
    </v-footer>   
</template>

<style scoped>
  .footer {
    font-size: 89%;
  }
</style>

<script>
export default {
    name: 'AppFooter'
}
</script>